import gql from "graphql-tag";

export const ADD_SLACK_BROADCAST = gql`
  mutation ($input: addSlackBroadcastChannelInput) {
    addSlackBroadcastChannel(input: $input) {
      _id
    }
  }
`;
